import {Box} from '@dropbox/dig-foundations';
import {type ReactNode} from 'react';

export const Panel = ({children, className}: {children: ReactNode; className?: string}) => (
  <Box
    className={className}
    borderRadius="Large"
    borderWidth="1"
    borderStyle="Solid"
    borderColor="Border Subtle"
    padding="16"
    backgroundColor="Background Base"
  >
    {children}
  </Box>
);
